import styles from './style.module.css';

export default function Arrow({ className, color, rotate, ...props }) {
	const cls = [styles.arrow];
	if (rotate) cls.push(styles[rotate]);
	if (className) cls.push(className);
	return <svg width="24px" height="24px" fill={color} className={cls.join(' ')} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z"/>
	</svg>
}